(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var timers = new WeakMap();
    var pausedByUser = new WeakMap();

    function rotate(el) {
      var slides = el.querySelectorAll('.announcement-bar__slide');
      if (slides.length < 2) return;
      var seconds = parseInt(el.getAttribute('data-rotate-seconds'), 10);
      if (!seconds || seconds <= 0) seconds = 5;
      var index = 0;
      var timer = setInterval(function () {
        slides[index].setAttribute('data-active', 'false');
        index = (index + 1) % slides.length;
        slides[index].setAttribute('data-active', 'true');
      }, seconds * 1000);
      timers.set(el, timer);
    }

    function stop(el) {
      var t = timers.get(el);
      if (t) { clearInterval(t); timers.delete(el); }
    }

    function init(el) {
      var slides = el.querySelectorAll('.announcement-bar__slide');
      if (slides.length > 1) el.classList.add('announcement-bar--multi');
      stop(el);
      if (!pausedByUser.get(el)) rotate(el);

      var pauseBtn = el.querySelector('[data-promo-pause]');
      var playBtn = el.querySelector('[data-promo-play]');
      if (pauseBtn && playBtn) {
        pauseBtn.addEventListener('click', function () {
          stop(el);
          pausedByUser.set(el, true);
          pauseBtn.setAttribute('hidden', '');
          playBtn.removeAttribute('hidden');
        });
        playBtn.addEventListener('click', function () {
          pausedByUser.set(el, false);
          rotate(el);
          playBtn.setAttribute('hidden', '');
          pauseBtn.removeAttribute('hidden');
        });
      }
    }

    function bootAll() {
      document.querySelectorAll('[data-section-type="announcement-bar"]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
    else bootAll();

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="announcement-bar"]');
      if (el) init(el);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var el = e.target.querySelector('[data-section-type="announcement-bar"]');
      if (el) stop(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function refreshDrawer() {
      var current = document.querySelector('[data-section-type="cart-drawer"]');
      if (!current) return Promise.resolve();
      var sectionId = current.getAttribute('data-section-id');
      return fetch(window.location.pathname + '?sections=' + sectionId)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data[sectionId]) return;
          var temp = document.createElement('div');
          temp.innerHTML = data[sectionId];
          var fresh = temp.querySelector('[data-section-type="cart-drawer"]');
          if (!fresh) return;
          var curPanel = current.querySelector('.cart-drawer__panel');
          var newPanel = fresh.querySelector('.cart-drawer__panel');
          if (curPanel && newPanel) {
            /* Swap ONLY the panel's inner content. The drawer root, the overlay
               and the panel element all stay mounted, so there is no
               hidden->shown flash and the slide-in animation never replays on a
               quantity change — that flash was the "cart opens and closes each
               time" bug. The overlay's close handler (bound once, outside the
               panel) survives; we only re-bind the controls inside the panel. */
            var body = curPanel.querySelector('.cart-drawer__body');
            var scroll = body ? body.scrollTop : 0;
            curPanel.innerHTML = newPanel.innerHTML;
            bind(curPanel);
            var newBody = curPanel.querySelector('.cart-drawer__body');
            if (newBody) newBody.scrollTop = scroll;
          } else {
            current.replaceWith(fresh);
            bind(fresh);
          }
        })
        .then(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          /* mark as coming FROM the drawer so the cart:update listener below
             does not call refreshDrawer again (that caused an infinite loop). */
          cart.__fromDrawer = true;
          document.dispatchEvent(new CustomEvent('cart:update', { detail: cart }));
        });
    }

    /* Change a line by its stable line-item key (id:hash) — NOT a positional
       index. /cart/change.js with { id: key } always targets the right line
       even when the rendered order differs from the server's cart order, which
       is what previously made "minus" hit the wrong item (looking like the
       quantity went up, or the item being impossible to remove). */
    function changeByKey(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
    }

    /* Serialize changes so a burst of clicks can't race each other, and only
       re-render once the burst has fully settled. */
    var chain = Promise.resolve();
    var pending = 0;
    function enqueue(key, qty) {
      pending++;
      chain = chain
        .then(function () { return changeByKey(key, qty); })
        .catch(function () {})
        .then(function () {
          pending--;
          if (pending === 0) return refreshDrawer();
        });
    }

    /* ===== Launch-offer pair management (Lip Plumper 1+1) =====
       Shopify SPLITS a discounted variant into separate paid/free lines with
       unstable grouping keys, and /cart/update.js keyed by variant id only
       touches one of those lines — so absolute variant updates are unreliable.
       The two safe primitives are: /cart/add.js to top UP (adds always merge),
       and per-line /cart/change.js with a fresh key to step DOWN. */
    function fetchCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); });
    }
    function plumperLines(cart) {
      return (cart.items || []).filter(function (i) { return i.handle === 'lip-plumper'; });
    }
    function plumperQty(cart) {
      return plumperLines(cart).reduce(function (s, i) { return s + i.quantity; }, 0);
    }
    function setPlumperTotal(target, attempts) {
      if (attempts === undefined) attempts = 6;
      if (attempts <= 0) return Promise.resolve();
      return fetchCart().then(function (cart) {
        var lines = plumperLines(cart);
        var qty = plumperQty(cart);
        if (qty === target || lines.length === 0) return;
        if (target > qty) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: lines[0].variant_id, quantity: target - qty })
          }).then(function () { return setPlumperTotal(target, attempts - 1); });
        }
        /* step down: shrink the last line with a FRESH key, then re-check —
           each change can regroup the remaining lines and rotate their keys. */
        var l = lines[lines.length - 1];
        var newQty = Math.max(0, l.quantity - (qty - target));
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: l.key, quantity: newQty })
        }).then(function () { return setPlumperTotal(target, attempts - 1); });
      });
    }
    /* Whenever the plumper count is odd, reconcile to a full pair: round UP
       when the customer just added, DOWN when they just reduced. Decisions are
       always made on a fresh snapshot and serialized on the same chain as the
       steppers. */
    function reconcilePairs() {
      chain = chain.then(function () {
        return fetchCart().then(function (cart) {
          var qty = plumperQty(cart);
          var last = parseInt(sessionStorage.getItem('kisPlumperQty') || '0', 10);
          sessionStorage.setItem('kisPlumperQty', String(qty));
          if (qty === 0 || qty % 2 === 0) return;
          var target = qty > last ? qty + 1 : qty - 1;
          sessionStorage.setItem('kisPlumperQty', String(target));
          return setPlumperTotal(target).then(function () { return refreshDrawer(); });
        });
      }).catch(function () { /* network/storage hiccup — try again on the next cart event */ });
    }
    document.addEventListener('cart:update', function () { reconcilePairs(); });
    reconcilePairs();

    function closeDrawer() {
      var wrapper = document.querySelector('[data-drawer="cart"]');
      if (wrapper) wrapper.setAttribute('hidden', '');
      if (!document.querySelector('[data-drawer]:not([hidden])')) {
        document.body.classList.remove('kis-nav-open');
      }
    }

    function bind(root) {
      /* close (X + overlay) — re-bound on every fresh node so closing keeps
         working after the drawer is re-rendered by refreshDrawer(). */
      root.querySelectorAll('[data-drawer-close="cart"]').forEach(function (el) {
        el.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(); });
      });

      root.querySelectorAll('[data-drawer-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.closest('.cart-drawer__line');
          if (!line) return;
          var key = line.getAttribute('data-line-key');
          if (!key) return;
          var step = parseInt(btn.getAttribute('data-drawer-qty-step'), 10);
          var pairVid = line.getAttribute('data-pair-variant');
          if (pairVid) {
            /* launch-offer product: quantities move in PAIRS (1 paid + 1 free).
               The stepper shows the paid count; the real variant total is 2×. */
            var total = 0;
            document.querySelectorAll('[data-pair-variant="' + pairVid + '"]').forEach(function (l) {
              total += parseInt(l.getAttribute('data-qty'), 10) || 0;
            });
            var pairs = Math.max(0, Math.floor(total / 2) + step);
            var newTotal = pairs * 2;
            if (newTotal === total) return;
            var valEl = line.querySelector('.cart-drawer__line-qty-val');
            if (valEl) valEl.textContent = Math.max(0, (parseInt(valEl.textContent, 10) || 0) + step);
            try { sessionStorage.setItem('kisPlumperQty', String(newTotal)); } catch (e) {}
            pending++;
            chain = chain
              .then(function () { return setPlumperTotal(newTotal); })
              .catch(function () {})
              .then(function () {
                pending--;
                if (pending === 0) return refreshDrawer();
              });
            return;
          }
          var current = parseInt(line.getAttribute('data-qty'), 10);
          if (isNaN(current)) current = 1;
          var next = Math.max(0, current + step);
          if (next === current) return;
          /* optimistic UI: update the displayed value immediately so rapid
             clicks compute from the right base and feel instant */
          line.setAttribute('data-qty', next);
          var valEl = line.querySelector('.cart-drawer__line-qty-val');
          if (valEl) valEl.textContent = next;
          if (next === 0) line.classList.add('cart-drawer__line--removing');
          enqueue(key, next);
        });
      });

      /* upsell slider arrows — one card per click */
      var upsellList = root.querySelector('[data-upsell-list]');
      if (upsellList) {
        var step = function () { return upsellList.clientWidth * 0.94 + 10; };
        var prev = root.querySelector('[data-upsell-prev]');
        var next = root.querySelector('[data-upsell-next]');
        if (prev) prev.addEventListener('click', function () { upsellList.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { upsellList.scrollBy({ left: step(), behavior: 'smooth' }); });
      }

      root.querySelectorAll('[data-drawer-upsell-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('.cart-drawer__upsell-item');
          var picked = card && card.querySelector('[data-upsell-variant]:checked');
          var vid = picked ? parseInt(picked.value, 10) : parseInt(btn.getAttribute('data-variant-id'), 10);
          if (!vid || btn.disabled) return;
          btn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: vid, quantity: 1 })
          })
            .catch(function () {})
            .then(function () { return refreshDrawer(); });
        });
      });

      root.querySelectorAll('[data-drawer-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.closest('.cart-drawer__line');
          if (!line) return;
          var key = line.getAttribute('data-line-key');
          if (!key) return;
          line.setAttribute('data-qty', 0);
          line.classList.add('cart-drawer__line--removing');
          var pairVid = line.getAttribute('data-pair-variant');
          if (pairVid) {
            /* removing a launch-offer product clears BOTH the paid and the
               free units — a lone free line must never turn into a paid one. */
            try { sessionStorage.setItem('kisPlumperQty', '0'); } catch (e) {}
            pending++;
            chain = chain
              .then(function () { return setPlumperTotal(0); })
              .catch(function () {})
              .then(function () {
                pending--;
                if (pending === 0) return refreshDrawer();
              });
            return;
          }
          enqueue(key, 0);
        });
      });
    }

    /* Escape closes the cart */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var w = document.querySelector('[data-drawer="cart"]');
      if (w && !w.hasAttribute('hidden')) closeDrawer();
    });

    document.querySelectorAll('[data-section-type="cart-drawer"]').forEach(bind);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="cart-drawer"]');
      if (el) bind(el);
    });

    document.addEventListener('cart:update', function (e) {
      if (e.detail && e.detail.__fromDrawer) return;
      refreshDrawer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["client-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('.client-results__card').forEach(function (card) {
        var text = card.querySelector('[data-cr-text]');
        var btn = card.querySelector('[data-cr-toggle]');
        if (!text || !btn) return;
        // show the toggle only when the text is actually clamped
        if (text.scrollHeight > text.clientHeight + 2) btn.removeAttribute('hidden');
        btn.addEventListener('click', function () {
          var expanded = card.classList.toggle('is-expanded');
          btn.querySelector('[data-cr-more]').toggleAttribute('hidden', expanded);
          btn.querySelector('[data-cr-less]').toggleAttribute('hidden', !expanded);
        });
      });
    }
    document.querySelectorAll('[data-section-type="client-results"]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="client-results"]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-faq]').forEach(function (det) {
        var summary = det.querySelector('summary');
        var body = det.querySelector('[data-faq-body]');
        if (!summary || !body) return;
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (body.classList.contains('is-animating')) return;
          if (det.open) {
            body.style.height = body.offsetHeight + 'px';
            body.classList.add('is-animating');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { body.style.height = '0px'; });
            });
            body.addEventListener('transitionend', function onEnd() {
              body.removeEventListener('transitionend', onEnd);
              det.open = false;
              body.classList.remove('is-animating');
              body.style.height = '';
            });
          } else {
            det.open = true;
            var target = body.scrollHeight;
            body.style.height = '0px';
            body.classList.add('is-animating');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { body.style.height = target + 'px'; });
            });
            body.addEventListener('transitionend', function onEnd() {
              body.removeEventListener('transitionend', onEnd);
              body.classList.remove('is-animating');
              body.style.height = '';
            });
          }
        });
      });
    }
    document.querySelectorAll('[data-section-type="faq-section"]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="faq-section"]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('[data-locale-select]').forEach(function (sel) {
      if (sel.dataset.bound) return;
      sel.dataset.bound = '1';
      sel.addEventListener('change', function () {
        var form = sel.closest('form');
        if (form) form.submit();
      });
    });
    setupLogoParallax(root);

    /* "Search" footer link opens the search drawer (same modal as the header) */
    root.querySelectorAll('a[href*="/search"]').forEach(function (link) {
      if (link.dataset.searchBound) return;
      link.dataset.searchBound = '1';
      link.addEventListener('click', function (e) {
        var drawer = document.querySelector('[data-drawer="search"]');
        if (!drawer) return;
        e.preventDefault();
        drawer.removeAttribute('hidden');
        document.body.classList.add('kis-nav-open');
      });
    });
  }

  /* Slight reference-style reveal: the giant wordmark rises + grows a touch as the
     footer scrolls into view, driven by scroll position (not a one-shot). */
  function setupLogoParallax(root) {
    if (root.dataset.logoAnim) return;
    var wrap = root.querySelector('.footer__logo');
    var mark = root.querySelector('.footer__logo-mark, .footer__logo-img');
    if (!wrap || !mark) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.dataset.logoAnim = '1';

    var active = false, ticking = false;

    function render() {
      ticking = false;
      var rect = wrap.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      /* 0 when the logo's top first enters from the bottom, 1 once it reaches ~35% up */
      var p = (vh - rect.top) / (vh * 0.65);
      p = Math.max(0, Math.min(1, p));
      var ty = (1 - p) * 42;              /* px — slides up */
      var scale = 0.93 + p * 0.07;        /* subtle grow to 1 */
      mark.style.transform = 'translateY(' + ty.toFixed(1) + 'px) scale(' + scale.toFixed(3) + ')';
    }
    function onScroll() {
      if (active && !ticking) { ticking = true; window.requestAnimationFrame(render); }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        active = entries[0].isIntersecting;
        if (active) render();
      }, { rootMargin: '0px 0px -5% 0px' }).observe(wrap);
    } else {
      active = true;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    render();
  }

  function boot() {
    document.querySelectorAll('[data-section-type="footer"]').forEach(init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var f = e.target.querySelector('[data-section-type="footer"]');
    if (f) init(f);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncNavToggle(open) {
      document.querySelectorAll('[data-nav-toggle]').forEach(function (b) {
        b.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    function openDrawer(d) {
      d.removeAttribute('hidden');
      document.body.classList.add('kis-nav-open');
      if (d.getAttribute('data-drawer') === 'mobile-nav') syncNavToggle(true);
    }
    function closeDrawer(d) {
      d.setAttribute('hidden', '');
      if (!document.querySelector('[data-drawer]:not([hidden])')) document.body.classList.remove('kis-nav-open');
      if (d.getAttribute('data-drawer') === 'mobile-nav') syncNavToggle(false);
    }

    /* The mobile-nav drawer lives inside the fixed + transformed .site-header, whose
       transform becomes the containing block for position:fixed — trapping the drawer
       in the header's tiny box. Move it to <body> so it can cover the full viewport. */
    function portalNavDrawer() {
      var d = document.querySelector('[data-drawer="mobile-nav"]');
      if (d && d.parentElement !== document.body) document.body.appendChild(d);
    }

    function bindDrawers(root) {
      document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
        if (btn.__kisBound) return; btn.__kisBound = true;
        btn.addEventListener('click', function () {
          var name = btn.getAttribute('data-drawer-open');
          var d = document.querySelector('[data-drawer="' + name + '"]');
          if (d) openDrawer(d);
        });
      });
      document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
        if (btn.__kisBound) return; btn.__kisBound = true;
        btn.addEventListener('click', function () {
          var name = btn.getAttribute('data-drawer-close');
          var d = document.querySelector('[data-drawer="' + name + '"]');
          if (d) closeDrawer(d);
        });
      });
      /* hamburger — toggles the mobile nav open/closed and animates to an X */
      document.querySelectorAll('[data-nav-toggle]').forEach(function (btn) {
        if (btn.__kisBound) return; btn.__kisBound = true;
        btn.addEventListener('click', function () {
          var d = document.querySelector('[data-drawer="mobile-nav"]');
          if (!d) return;
          if (d.hasAttribute('hidden')) openDrawer(d); else closeDrawer(d);
        });
      });
    }

    /* ---------- MEGA-MENU ---------- */
    function waitForSwiper(cb, tries) {
      tries = tries || 0;
      if (typeof window.Swiper !== 'undefined') { cb(); return; }
      if (tries > 40) return;
      setTimeout(function () { waitForSwiper(cb, tries + 1); }, 75);
    }

    function setupMega(header) {
      var root = header.querySelector('[data-mega-root]');
      var panel = header.querySelector('[data-mega-panel]');
      if (!root || !panel) return;

      var tabs = [].slice.call(panel.querySelectorAll('[data-mega-tab]'));
      var indicator = panel.querySelector('[data-mega-indicator]');
      var openTimer, closeTimer;

      function moveIndicator(tab) {
        if (!indicator || !tab) return;
        indicator.style.width = tab.offsetWidth + 'px';
        indicator.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
      }

      function open() {
        clearTimeout(closeTimer);
        header.classList.add('mega-open');
        panel.setAttribute('aria-hidden', 'false');
        var trigger = root.querySelector('[data-mega-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        var active = panel.querySelector('.mega__tab.is-active') || tabs[0];
        moveIndicator(active);
        if (header.__megaMaster) header.__megaMaster.update();
        (header.__megaProducts || []).forEach(function (s) { s.update(); });
      }
      function close() {
        header.classList.remove('mega-open');
        panel.setAttribute('aria-hidden', 'true');
        var trigger = root.querySelector('[data-mega-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
      function scheduleClose() { clearTimeout(closeTimer); closeTimer = setTimeout(close, 200); }
      function scheduleOpen() { clearTimeout(openTimer); openTimer = setTimeout(open, 60); }

      root.addEventListener('mouseenter', scheduleOpen);
      root.addEventListener('mouseleave', function () { clearTimeout(openTimer); });
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      root.addEventListener('mouseleave', scheduleClose);
      panel.addEventListener('mouseleave', scheduleClose);

      var trigger = root.querySelector('[data-mega-trigger]');
      if (trigger) trigger.addEventListener('focus', open);

      header.querySelectorAll('[data-mega-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });

      waitForSwiper(function () {
        // per-category product carousels
        var products = [].slice.call(panel.querySelectorAll('[data-mega-products]')).map(function (el) {
          return new window.Swiper(el, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            centerInsufficientSlides: true,
            navigation: {
              nextEl: panel.querySelector('[data-mega-next]'),
              prevEl: panel.querySelector('[data-mega-prev]')
            },
            watchOverflow: true
          });
        });
        header.__megaProducts = products;

        // master swiper switching categories
        var masterEl = panel.querySelector('[data-mega-master]');
        var master = new window.Swiper(masterEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          autoHeight: true,
          allowTouchMove: false,
          speed: 450,
          on: {
            slideChange: function () {
              var i = this.activeIndex;
              tabs.forEach(function (t, ti) {
                var on = ti === i;
                t.classList.toggle('is-active', on);
                t.setAttribute('aria-selected', on ? 'true' : 'false');
                if (on) moveIndicator(t);
              });
              if (products[i]) products[i].update();
            }
          }
        });
        header.__megaMaster = master;

        tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function () { master.slideTo(i); });
          tab.addEventListener('mouseenter', function () { master.slideTo(i); });
        });
      });
    }

    /* ---------- SCROLL BEHAVIOR (3 states) ---------- */
    function setupScrollBehavior(header) {
      var lastScrollY = 0;
      var ticking = false;

      /* Pages without a dark hero behind the header (product, cart, collection…)
         render the header in its solid/legible state from the very top. */
      var hasHero = !!document.querySelector('.hero, [data-section-type="hero"]');
      if (!hasHero) header.classList.add('is-solid');

      function getHideThreshold() {
        var hero = document.querySelector('.hero, [data-section-type="hero"]');
        if (!hero) return 200;
        var rect = hero.getBoundingClientRect();
        var heroTop = rect.top + window.scrollY;
        return heroTop + rect.height * 0.4;
      }

      function onScroll() {
        var y = window.scrollY;
        var hideAt = getHideThreshold();
        var direction = y > lastScrollY ? 'down' : 'up';
        var scrolled = y > 30;
        var pastHideAt = y > hideAt;

        if (scrolled) {
          header.classList.add('is-scrolled');
          header.setAttribute('data-header-color', 'dark');
        } else {
          header.classList.remove('is-scrolled');
          header.setAttribute('data-header-color', 'light');
        }

        if (pastHideAt && direction === 'down') {
          header.classList.add('is-hidden');
        } else if (direction === 'up' || !pastHideAt) {
          header.classList.remove('is-hidden');
        }

        lastScrollY = y;
        ticking = false;
      }

      window.addEventListener('scroll', function () {
        if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
      }, { passive: true });

      onScroll();
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-drawer]:not([hidden])').forEach(closeDrawer);
        document.querySelectorAll('[data-section-type="site-header"].mega-open').forEach(function (h) { h.classList.remove('mega-open'); });
      }
    });

    /* Mobile menu — tap a category tab to switch the visible product panel */
    function setupMnav() {
      var menu = document.querySelector('[data-drawer="mobile-nav"]');
      if (!menu || menu.dataset.mnavReady) return;
      var tabs = [].slice.call(menu.querySelectorAll('[data-mnav-tab]'));
      var track = menu.querySelector('[data-mnav-track]');
      var panels = [].slice.call(menu.querySelectorAll('[data-mnav-panel]'));
      var tabsRow = menu.querySelector('.mnav__tabs');
      var viewport = menu.querySelector('.mnav__panels');
      if (!tabs.length || !track) return;
      menu.dataset.mnavReady = '1';

      var index = 0;

      function centerTab(i) {
        var t = tabs[i];
        if (!t || !tabsRow) return;
        var target = t.offsetLeft - (tabsRow.clientWidth - t.offsetWidth) / 2;
        tabsRow.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }

      function go(i, instant) {
        index = Math.max(0, Math.min(panels.length - 1, i));
        if (instant) track.classList.add('is-dragging');
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        if (instant) { void track.offsetWidth; track.classList.remove('is-dragging'); }
        tabs.forEach(function (t, ti) {
          var on = ti === index;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        centerTab(index);
        if (panels[index]) panels[index].scrollTop = 0;
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { go(i); });
      });

      /* horizontal swipe between categories — vertical scroll stays native (touch-action: pan-y) */
      var down = false, sx = 0, sy = 0, dx = 0, decided = false, horizontal = false, w = 1;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        down = true; decided = false; horizontal = false; dx = 0;
        sx = e.clientX; sy = e.clientY;
        w = (viewport && viewport.clientWidth) || 1;
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var mx = e.clientX - sx, my = e.clientY - sy;
        if (!decided) {
          if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
          decided = true;
          horizontal = Math.abs(mx) > Math.abs(my);
          if (horizontal) { track.classList.add('is-dragging'); try { track.setPointerCapture(e.pointerId); } catch (err) {} }
        }
        if (!horizontal) return;
        e.preventDefault();
        dx = mx;
        var resist = ((index === 0 && dx > 0) || (index === panels.length - 1 && dx < 0)) ? 0.35 : 1;
        track.style.transform = 'translateX(calc(' + (-index * 100) + '% + ' + (dx * resist) + 'px))';
      });
      function endDrag(e) {
        if (!down) return;
        down = false;
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
        track.classList.remove('is-dragging');
        if (horizontal) {
          var threshold = w * 0.18;
          if (dx <= -threshold) go(index + 1);
          else if (dx >= threshold) go(index - 1);
          else go(index);
        }
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      /* country/region selector — reload with the chosen locale on change */
      menu.querySelectorAll('[data-mnav-locale]').forEach(function (sel) {
        if (sel.__locBound) return; sel.__locBound = true;
        sel.addEventListener('change', function () { var f = sel.closest('form'); if (f) f.submit(); });
      });

      go(0, true);
    }

    function init(header) {
      portalNavDrawer();
      setupMnav();
      bindDrawers(header);
      setupScrollBehavior(header);
      setupMega(header);
    }

    document.querySelectorAll('[data-section-type="site-header"]').forEach(init);

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="site-header"]');
      if (el) init(el);
    });

    function refreshCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
      /* the reference: hide the superscript badge when the cart is empty */
      document.querySelectorAll('.site-header__cart-badge').forEach(function (b) {
        b.classList.toggle('is-empty', !count || count === '0');
      });
    }
    /* initial state from the server-rendered count */
    (function () {
      var b = document.querySelector('.site-header__cart-badge');
      var n = b ? parseInt(b.textContent, 10) : 0;
      refreshCartCount(isNaN(n) ? 0 : n);
    })();

    document.addEventListener('cart:update', function (e) {
      var count = (e.detail && typeof e.detail.item_count === 'number') ? e.detail.item_count : null;
      if (count === null) return;
      refreshCartCount(count);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var instances = {};

    function init(section) {
      var track = section.querySelector('[data-ing-track]');
      if (!track || track.dataset.ingReady) return;
      track.dataset.ingReady = '1';

      var sectionId = section.getAttribute('data-section-id');
      var next = section.querySelector('[data-ing-next]');
      var dotsWrap = section.querySelector('[data-ing-dots]');
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];

      function step() {
        var card = track.querySelector('.ingredients-slider__card');
        if (!card) return 360;
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function maxScroll() { return track.scrollWidth - track.clientWidth; }

      function update() {
        if (next) next.disabled = track.scrollLeft >= maxScroll() - 4;
        if (dots.length) {
          var idx = Math.round(track.scrollLeft / step());
          idx = Math.max(0, Math.min(dots.length - 1, idx));
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === idx);
          });
        }
      }

      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(update);
      }, { passive: true });

      function onResize() { update(); }
      window.addEventListener('resize', onResize);
      instances[sectionId] = { onResize: onResize };
      update();

      /* --- drag-to-scroll (desktop pointer only; native touch scroll on mobile) --- */
      var DRAG_THRESHOLD = 6;
      var isDown = false, dragStartX = 0, dragStartScroll = 0, dragMoved = false, suppressClick = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        isDown = true;
        dragMoved = false;
        dragStartX = e.clientX;
        dragStartScroll = track.scrollLeft;
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - dragStartX;
        if (!dragMoved && Math.abs(dx) > DRAG_THRESHOLD) {
          dragMoved = true;
          track.style.scrollSnapType = 'none';
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (dragMoved) {
          track.scrollLeft = dragStartScroll - dx;
          e.preventDefault();
        }
      });

      function endDrag(e) {
        if (!isDown) return;
        isDown = false;
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
        if (dragMoved) {
          suppressClick = true;
          track.style.scrollSnapType = '';
        }
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      track.addEventListener('click', function (e) {
        if (suppressClick) {
          e.preventDefault();
          e.stopPropagation();
          suppressClick = false;
        }
      }, true);

      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      /* --- "swipe" custom drag cursor (fine pointers only) --- */
      var cursor = section.querySelector('[data-ing-cursor]');
      var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (cursor && finePointer) {
        var rafId = null;
        var pendingX = 0, pendingY = 0;

        function place() {
          rafId = null;
          cursor.style.transform = 'translate(' + (pendingX - 60) + 'px, ' + (pendingY - 60) + 'px)';
        }
        function onMove(e) {
          pendingX = e.clientX;
          pendingY = e.clientY;
          if (rafId === null) rafId = window.requestAnimationFrame(place);
        }
        track.addEventListener('mouseenter', function (e) {
          pendingX = e.clientX; pendingY = e.clientY; place();
          section.classList.add('is-cursor-active');
        });
        track.addEventListener('mousemove', onMove);
        track.addEventListener('mouseleave', function () {
          section.classList.remove('is-cursor-active');
        });
        if (next) {
          next.addEventListener('mouseenter', function () { section.classList.remove('is-cursor-active'); });
        }
      }
    }

    function teardown(sectionId) {
      var inst = instances[sectionId];
      if (!inst) return;
      window.removeEventListener('resize', inst.onResize);
      delete instances[sectionId];
    }

    document.querySelectorAll('[data-section-type="ingredients-slider"]').forEach(init);

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="ingredients-slider"]');
      if (el) init(el);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var el = e.target.querySelector('[data-section-type="ingredients-slider"]');
      if (el) teardown(el.getAttribute('data-section-id'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Change a line by its stable line-item key (id:hash), never a positional
       index — the index desyncs from the server's cart order and makes a click
       hit the wrong row. */
    function updateCart(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      }).then(function (r) { return r.json(); });
    }

    function refreshSection(section) {
      var sectionId = section.getAttribute('data-section-id');
      return fetch(window.location.pathname + '?sections=' + sectionId)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data[sectionId]) {
            var temp = document.createElement('div');
            temp.innerHTML = data[sectionId];
            var fresh = temp.querySelector('[data-section-type="main-cart"]');
            if (fresh) {
              section.replaceWith(fresh);
              bind(fresh);
            }
          }
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', { detail: cart }));
        });
    }

    function bind(section) {
      var qtyBtns = section.querySelectorAll('[data-qty-step]');
      var qtyInputs = section.querySelectorAll('[data-qty-input]');
      var removeBtns = section.querySelectorAll('[data-remove-line]');

      qtyBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var li = btn.closest('.cart-line');
          if (!li) return;
          var key = li.getAttribute('data-line-key');
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var input = li.querySelector('[data-qty-input]');
          var val = parseInt(input.value, 10) || 0;
          val = Math.max(0, val + step);
          input.value = val;
          updateCart(key, val).then(function () { refreshSection(section); });
        });
      });

      qtyInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          var li = input.closest('.cart-line');
          if (!li) return;
          var key = li.getAttribute('data-line-key');
          var val = parseInt(input.value, 10) || 0;
          updateCart(key, val).then(function () { refreshSection(section); });
        });
      });

      removeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var li = btn.closest('.cart-line');
          if (!li) return;
          var key = li.getAttribute('data-line-key');
          updateCart(key, 0).then(function () { refreshSection(section); });
        });
      });
    }

    document.querySelectorAll('[data-section-type="main-cart"]').forEach(bind);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="main-cart"]');
      if (el) bind(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-section-type="main-collection"]').forEach(function (section) {
    // custom sort dropdown
    var sort = section.querySelector('[data-sort]');
    if (sort) {
      var trigger = sort.querySelector('[data-sort-trigger]');
      var popup = sort.querySelector('[data-sort-popup]');
      var close = function () { popup.hidden = true; sort.removeAttribute('data-open'); trigger.setAttribute('aria-expanded', 'false'); };
      var closeBtn = sort.querySelector('[data-sort-close]');
      if (closeBtn) closeBtn.addEventListener('click', function (e) { e.stopPropagation(); close(); });
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !popup.hidden;
        if (open) { close(); } else { popup.hidden = false; sort.setAttribute('data-open', ''); trigger.setAttribute('aria-expanded', 'true'); }
      });
      popup.querySelectorAll('[data-sort-value]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', opt.getAttribute('data-sort-value'));
          url.searchParams.delete('page');
          window.location.assign(url.toString());
        });
      });
      document.addEventListener('click', function (e) { if (!sort.contains(e.target)) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }

    // grid density toggle
    var grid = section.querySelector('.rcol__grid');
    var colBtns = section.querySelectorAll('.rcol__cols');
    if (grid && colBtns.length) {
      var saved = null;
      try { saved = localStorage.getItem('rcol-cols'); } catch (e) {}
      var applyCols = function (cols) {
        grid.classList.remove('rcol__grid--cols-2', 'rcol__grid--cols-3');
        if (cols === '2') grid.classList.add('rcol__grid--cols-2');
        colBtns.forEach(function (b) { b.setAttribute('data-selected', b.getAttribute('data-cols') === cols ? 'true' : 'false'); });
      };
      if (saved) applyCols(saved);
      colBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var cols = b.getAttribute('data-cols');
          applyCols(cols);
          try { localStorage.setItem('rcol-cols', cols); } catch (e) {}
        });
      });
    }

    // scroll reveal (progressive enhancement)
    var grid = section.querySelector('.rcol__grid');
    if (grid && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      grid.classList.add('rcol--reveal');
      var items = grid.querySelectorAll('.rcol__item');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      items.forEach(function (el) { io.observe(el); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var form = section.querySelector('[data-product-form]');
      if (!form) return;
      var qtyInput = section.querySelector('[data-qty-input]');
      var qtyBtns = section.querySelectorAll('[data-qty-step]');
      var thumbs = section.querySelectorAll('[data-thumb-target]');
      var mediaItems = section.querySelectorAll('[data-media-id]');
      var submit = section.querySelector('[data-add-to-cart]');
      var defaultText = section.querySelector('[data-add-default]');
      var loadingText = section.querySelector('[data-add-loading]');

      // Complete the routine: quick add + open the cart drawer
      section.querySelectorAll('[data-routine-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
          if (!vid || btn.disabled) return;
          btn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: vid, quantity: 1 })
          })
            .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:update', { detail: cart }));
              var drawer = document.querySelector('[data-drawer="cart"]');
              if (drawer) { drawer.removeAttribute('hidden'); document.body.classList.add('kis-nav-open'); }
            })
            .finally(function () { btn.disabled = false; });
        });
      });

      // Bundle offer: the selected option drives the quantity + per-unit shade pickers
      function syncBundleShades() {
        var shades = section.querySelector('[data-bundle-shades]');
        if (!shades) return;
        var checked = section.querySelector('[data-bundle-qty]:checked');
        if (checked && parseInt(checked.value, 10) > 1) shades.removeAttribute('hidden');
        else shades.setAttribute('hidden', '');
      }
      section.querySelectorAll('[data-bundle-qty]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked && qtyInput) qtyInput.value = radio.value;
          syncBundleShades();
        });
      });
      var bundleChecked = section.querySelector('[data-bundle-qty]:checked');
      if (bundleChecked && qtyInput) qtyInput.value = bundleChecked.value;
      syncBundleShades();

      // Accordions: reference-style smooth slide (height animation on the body wrapper)
      section.querySelectorAll('[data-accordion]').forEach(function (det) {
        var summary = det.querySelector('summary');
        var body = det.querySelector('[data-accordion-body]');
        if (!summary || !body) return;
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (body.classList.contains('is-animating')) return;
          if (det.open) {
            body.style.height = body.offsetHeight + 'px';
            body.classList.add('is-animating');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { body.style.height = '0px'; });
            });
            body.addEventListener('transitionend', function onEnd() {
              body.removeEventListener('transitionend', onEnd);
              det.open = false;
              body.classList.remove('is-animating');
              body.style.height = '';
            });
          } else {
            det.open = true;
            var target = body.scrollHeight;
            body.style.height = '0px';
            body.classList.add('is-animating');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { body.style.height = target + 'px'; });
            });
            body.addEventListener('transitionend', function onEnd() {
              body.removeEventListener('transitionend', onEnd);
              body.classList.remove('is-animating');
              body.style.height = '';
            });
          }
        });
      });

      // Qty +/-
      qtyBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var val = parseInt(qtyInput.value, 10) || 1;
          val = Math.max(1, val + step);
          qtyInput.value = val;
        });
      });

      // Thumbnails — click OR hover switches the displayed media (the reference)
      function activateThumb(thumb) {
        var id = thumb.getAttribute('data-thumb-target');
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); t.setAttribute('aria-selected', t === thumb ? 'true' : 'false'); });
        mediaItems.forEach(function (m) {
          if (m.getAttribute('data-media-id') === id) m.removeAttribute('hidden');
          else m.setAttribute('hidden', '');
        });
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { activateThumb(thumb); });
        thumb.addEventListener('mouseenter', function () { activateThumb(thumb); });
      });

      // Mobile gallery: swipe carousel + progress bar (the [hidden] attr is neutralized by CSS <=1024px)
      var mediaMain = section.querySelector('[data-product-media]');
      var mediaBarFill = section.querySelector('[data-media-bar-fill]');
      if (mediaMain && mediaBarFill) {
        var barTick = false;
        function visibleCount() {
          var n = 0;
          mediaMain.querySelectorAll('.product__media-item').forEach(function (m) { if (!m.classList.contains('is-group-hidden')) n++; });
          return n || 1;
        }
        function syncBar() {
          barTick = false;
          var barCount = visibleCount();
          mediaBarFill.style.width = (100 / barCount) + '%';
          var max = mediaMain.scrollWidth - mediaMain.clientWidth;
          if (max <= 0) return;
          var progress = Math.min(1, Math.max(0, mediaMain.scrollLeft / max));
          mediaBarFill.style.transform = 'translateX(' + (progress * (barCount - 1) * 100) + '%)';
        }
        mediaMain.addEventListener('scroll', function () {
          if (!barTick) { barTick = true; window.requestAnimationFrame(syncBar); }
        }, { passive: true });
        window.addEventListener('resize', syncBar);
      }

      // Per-image fit: squarish / landscape photos fill the card (cover); tall
      // product packshots stay fully visible (contain). Threshold on aspect ratio.
      section.querySelectorAll('.product__media-image').forEach(function (im) {
        function decide() {
          if (im.classList.contains('is-packshot')) return;
          if (!im.naturalWidth) return;
          var cover = (im.naturalWidth / im.naturalHeight) >= 0.9;
          im.classList.toggle('is-cover', cover);
          im.classList.toggle('is-contain', !cover);
        }
        if (im.complete && im.naturalWidth) decide();
        else im.addEventListener('load', decide, { once: true });
      });

      // Add to cart via fetch
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (submit.disabled) return;
        submit.disabled = true;
        if (defaultText) defaultText.setAttribute('hidden', '');
        if (loadingText) loadingText.removeAttribute('hidden');

        /* bundle with per-unit shades: add each chosen variant (e.g. 2× Cacao + 1× Berry) */
        var bundleSel = section.querySelector('[data-bundle-qty]:checked');
        var shadeSelects = section.querySelectorAll('[data-bundle-shades]:not([hidden]) [data-bundle-shade]:checked');
        var multiItems = null;
        if (bundleSel && parseInt(bundleSel.value, 10) > 1 && shadeSelects.length) {
          var counts = {};
          shadeSelects.forEach(function (s) { counts[s.value] = (counts[s.value] || 0) + 1; });
          multiItems = [];
          Object.keys(counts).forEach(function (val) {
            var v = variants.filter(Boolean).find(function (x) { return x.options[0] === val; });
            if (v) multiItems.push({ id: v.id, quantity: counts[val] });
          });
          if (!multiItems.length) multiItems = null;
        }

        var formData = new FormData(form);
        var addRequest = multiItems
          ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: multiItems }) })
          : fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
        addRequest
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok) throw result.data;
            return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            // Broadcast cart update so header + drawer refresh
            document.dispatchEvent(new CustomEvent('cart:update', { detail: cart }));
            // Open the drawer
            var drawer = document.querySelector('[data-drawer="cart"]');
            if (drawer) {
              drawer.removeAttribute('hidden');
              document.body.style.overflow = 'hidden';
            }
          })
          .catch(function (err) {
            console.warn('add-to-cart failed', err);
            if (loadingText) loadingText.setAttribute('hidden', '');
            if (defaultText) defaultText.removeAttribute('hidden');
            alert((err && err.description) || 'Could not add to cart');
          })
          .finally(function () {
            submit.disabled = false;
            setTimeout(function () {
              if (loadingText) loadingText.setAttribute('hidden', '');
              if (defaultText) defaultText.removeAttribute('hidden');
            }, 400);
          });
      });

      // === Variant selection (updates hidden id + price + sticky bar) ===
      var variantInput = section.querySelector('[data-variant-input]');
      var variants = [];
      try { variants = JSON.parse(section.querySelector('[data-pdp-variants]').textContent); } catch (e) {}
      var priceEl = section.querySelector('[data-product-price]');
      var stickyPrice = section.querySelector('[data-sticky-price]');
      var stickyAdd = section.querySelector('[data-sticky-add]');
      var stickySwatches = section.querySelectorAll('[data-sticky-swatch]');
      var stickySelect = section.querySelector('[data-sticky-select]');
      var stickyVariantSwatch = section.querySelector('[data-sticky-variant-swatch]');
      var stickyAddPrice = section.querySelector('[data-sticky-add-price]');

      // mobile pill: mirror the selected main swatch (color + value) into the sticky bar
      function paintStickyVariant() {
        if (!stickySelect) return;
        var pos = stickySelect.getAttribute('data-option-pos');
        var checked = section.querySelector('input[data-option-input][data-option-pos="' + pos + '"]:checked');
        if (!checked) return;
        stickySelect.value = checked.value;
        if (stickyVariantSwatch) {
          var label = checked.closest('label');
          var sw = label ? label.querySelector('.product__swatch') : null;
          if (sw) {
            var st = getComputedStyle(sw);
            if (st.backgroundImage && st.backgroundImage !== 'none') {
              stickyVariantSwatch.style.backgroundImage = st.backgroundImage;
              stickyVariantSwatch.style.backgroundColor = '';
            } else {
              stickyVariantSwatch.style.backgroundImage = '';
              stickyVariantSwatch.style.backgroundColor = st.backgroundColor;
            }
          }
        }
      }
      if (stickySelect) {
        stickySelect.addEventListener('change', function () {
          var pos = stickySelect.getAttribute('data-option-pos');
          section.querySelectorAll('input[data-option-input][data-option-pos="' + pos + '"]').forEach(function (r) {
            if (r.value === stickySelect.value) {
              r.checked = true;
              r.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      }

      function selectedOptions() {
        var opts = [];
        section.querySelectorAll('.product__option').forEach(function (fs) {
          var checked = fs.querySelector('input[data-option-input]:checked');
          opts.push(checked ? checked.value : null);
        });
        return opts;
      }
      function updateVariant() {
        var opts = selectedOptions();
        if (!opts.length) return;
        var v = variants.filter(Boolean).find(function (x) {
          return x.options.length === opts.length && x.options.every(function (o, i) { return o === opts[i]; });
        });
        if (!v) return;
        if (variantInput) variantInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price;
        if (stickyPrice) stickyPrice.textContent = v.price;
        if (stickyAddPrice) stickyAddPrice.textContent = ' — ' + v.price;
        paintStickyVariant();

        /* variant-scoped media: hide images tagged for another variant (filename/alt) */
        var optsDown = (v.options || []).map(function (o) { return String(o).toLowerCase(); });
        section.querySelectorAll('[data-media-group]').forEach(function (el) {
          var g = el.getAttribute('data-media-group');
          if (!g) return;
          el.classList.toggle('is-group-hidden', optsDown.indexOf(g) === -1);
        });

        /* always reset the gallery to the variant's first photo: its own
           featured media if set, else the first image visible for this variant */
        var targetItem = null;
        if (v.media_id) {
          mediaItems.forEach(function (m) { if (!targetItem && !m.classList.contains('is-group-hidden') && m.getAttribute('data-media-id') == v.media_id) targetItem = m; });
        }
        if (!targetItem) {
          mediaItems.forEach(function (m) { if (!targetItem && !m.classList.contains('is-group-hidden')) targetItem = m; });
        }
        if (targetItem) {
          var targetId = targetItem.getAttribute('data-media-id');
          mediaItems.forEach(function (m) {
            if (m === targetItem) m.removeAttribute('hidden');
            else m.setAttribute('hidden', '');
          });
          thumbs.forEach(function (t) {
            var on = t.getAttribute('data-thumb-target') == targetId;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          if (mediaMain && window.matchMedia('(max-width: 1024px)').matches) {
            /* index among VISIBLE items (hidden ones are removed from the scroll flow) */
            var scrollIdx = 0, seen = 0;
            mediaItems.forEach(function (m) {
              if (m.classList.contains('is-group-hidden')) return;
              if (m === targetItem) scrollIdx = seen;
              seen++;
            });
            mediaMain.scrollTo({ left: scrollIdx * mediaMain.clientWidth, behavior: 'smooth' });
            if (typeof syncBar === 'function') window.requestAnimationFrame(syncBar);
          }
        }
        section.querySelectorAll('.product__option').forEach(function (fs) {
          var disp = fs.querySelector('[data-option-display]');
          var checked = fs.querySelector('input[data-option-input]:checked');
          if (disp && checked) disp.textContent = checked.value;
        });
        if (submit) {
          submit.disabled = !v.available;
          var dtxt = submit.querySelector('[data-add-default]');
          if (dtxt) dtxt.textContent = v.available ? (submit.getAttribute('data-text-add') || 'Add to cart') : (submit.getAttribute('data-text-sold-out') || 'Sold out');
        }
        if (stickyAdd) {
          stickyAdd.disabled = !v.available;
          var stxt = stickyAdd.querySelector('[data-sticky-add-text]');
          if (stxt) stxt.textContent = v.available ? (stickyAdd.getAttribute('data-text-add') || 'Add to cart') : ((submit && submit.getAttribute('data-text-sold-out')) || 'Sold out');
        }
        stickySwatches.forEach(function (sw) {
          var pos = parseInt(sw.getAttribute('data-option-pos'), 10);
          sw.classList.toggle('is-active', sw.getAttribute('data-value') === opts[pos]);
        });
      }
      section.querySelectorAll('[data-option-input]').forEach(function (i) {
        i.addEventListener('change', updateVariant);
      });

      // sticky swatches: pull their colour from the matching main swatch, and sync selection on click
      stickySwatches.forEach(function (sw) {
        var pos = sw.getAttribute('data-option-pos');
        var val = sw.getAttribute('data-value');
        var mainRadio = null;
        section.querySelectorAll('input[data-option-input][data-option-pos="' + pos + '"]').forEach(function (r) {
          if (r.value === val) mainRadio = r;
        });
        if (mainRadio) {
          var mainSw = mainRadio.closest('label') ? mainRadio.closest('label').querySelector('.product__swatch') : null;
          if (mainSw) {
            var st = getComputedStyle(mainSw);
            if (st.backgroundImage && st.backgroundImage !== 'none') sw.style.backgroundImage = st.backgroundImage;
            else sw.style.backgroundColor = st.backgroundColor;
          }
          sw.addEventListener('click', function () {
            mainRadio.checked = true;
            mainRadio.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
      });

      // sticky "add to cart" → submit the product form via AJAX (same handler as the main button)
      if (stickyAdd) {
        stickyAdd.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }

      // === Sticky bar: show once the main buy row has scrolled above the viewport ===
      var stickyBar = section.querySelector('[data-sticky-bar]');
      var buyRow = section.querySelector('.product__buy-row');
      if (stickyBar && buyRow) {
        var scrollTick = false;
        function syncSticky() {
          scrollTick = false;
          var r = buyRow.getBoundingClientRect();
          /* hide near the very bottom so the footer's legal/bottom bar stays readable */
          var nearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 140;
          stickyBar.classList.toggle('is-visible', r.bottom < 8 && !nearBottom);
        }
        window.addEventListener('scroll', function () {
          if (!scrollTick) { scrollTick = true; window.requestAnimationFrame(syncSticky); }
        }, { passive: true });
        window.addEventListener('resize', syncSticky);
        syncSticky();
      }

      updateVariant();
    }

    document.querySelectorAll('[data-section-type="main-product"]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="main-product"]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-related"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var track = section.querySelector('[data-rel-track]');
      if (!track || track.dataset.relReady) return;
      track.dataset.relReady = '1';
      var prev = section.querySelector('[data-rel-prev]');
      var next = section.querySelector('[data-rel-next]');

      function step() {
        var first = track.querySelector('.pdp-rel__item');
        if (!first) return 320;
        var second = first.nextElementSibling;
        if (second) return second.getBoundingClientRect().left - first.getBoundingClientRect().left;
        return first.getBoundingClientRect().width + 20;
      }
      function update() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth;
        prev.toggleAttribute('disabled', track.scrollLeft <= 4);
        next.toggleAttribute('disabled', track.scrollLeft >= max - 4);
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();

      /* drag-to-scroll (capture the pointer ONLY once a real drag starts, so
         card links / quick-add buttons still receive their click) */
      var down = false, sx = 0, sl = 0, moved = false, suppress = false;
      var TH = 6;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (!moved && Math.abs(dx) > TH) {
          moved = true; track.classList.add('is-dragging'); track.style.scrollSnapType = 'none';
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (moved) { track.scrollLeft = sl - dx; e.preventDefault(); }
      });
      function end(e) {
        if (!down) return;
        down = false;
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
        if (moved) { suppress = true; track.classList.remove('is-dragging'); track.style.scrollSnapType = ''; }
      }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('click', function (e) { if (suppress) { e.preventDefault(); e.stopPropagation(); suppress = false; } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      /* quick add-to-cart (same flow as the homepage carousel) */
      section.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-pc-add]');
        if (!form) return;
        e.preventDefault();
        var btn = form.querySelector('[data-pc-add-btn]');
        if (btn && btn.disabled) return;
        if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        })
          .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
          .then(function (r) {
            if (!r.ok) throw r.data;
            return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); });
          })
          .then(function (cart) {
            var drawer = document.querySelector('[data-drawer="cart"]');
            if (drawer) { drawer.removeAttribute('hidden'); document.body.classList.add('kis-nav-open'); }
            document.dispatchEvent(new CustomEvent('cart:update', { detail: cart }));
          })
          .catch(function (err) {
            console.warn('quick add failed', err);
            alert((err && err.description) || 'Could not add to cart');
          })
          .finally(function () {
            if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
          });
      });
    }

    document.querySelectorAll('[data-section-type="pdp-related"]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="pdp-related"]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var track = section.querySelector('[data-pc-track]');
      if (!track) return;
      var prev = section.querySelector('[data-pc-prev]');
      var next = section.querySelector('[data-pc-next]');

      function stepSize() {
        var first = track.querySelector('.product-card');
        if (!first) return 320;
        var second = first.nextElementSibling;
        if (second) {
          return second.getBoundingClientRect().left - first.getBoundingClientRect().left;
        }
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0');
        return first.getBoundingClientRect().width + (isNaN(gap) ? 0 : gap);
      }

      function updateButtons() {
        if (!prev || !next) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft <= 4) prev.setAttribute('disabled', '');
        else prev.removeAttribute('disabled');
        if (track.scrollLeft >= maxScroll - 4) next.setAttribute('disabled', '');
        else next.removeAttribute('disabled');
      }

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -stepSize(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: stepSize(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateButtons);
      }, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();

      /* --- drag-to-scroll: lets the mouse swipe cards without following
             the card link. A swipe (pointer moved past threshold) scrolls
             the track and cancels the click; a genuine click still works. --- */
      var DRAG_THRESHOLD = 6;
      var isDown = false, dragStartX = 0, dragStartScroll = 0, dragMoved = false, suppressClick = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0) return; /* keep native touch scroll */
        isDown = true;
        dragMoved = false;
        dragStartX = e.clientX;
        dragStartScroll = track.scrollLeft;
        /* NB: do NOT capture the pointer here — capturing on pointerdown steals the
           click event from buttons/links inside the track (the add-to-cart button
           never fires). Capture only once a real drag starts (see pointermove). */
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - dragStartX;
        if (!dragMoved && Math.abs(dx) > DRAG_THRESHOLD) {
          dragMoved = true;
          track.style.scrollSnapType = 'none'; /* free drag, no snap fighting */
          try { track.setPointerCapture(e.pointerId); } catch (err) {} /* capture only when dragging */
        }
        if (dragMoved) {
          track.scrollLeft = dragStartScroll - dx;
          e.preventDefault();
        }
      });

      function endDrag(e) {
        if (!isDown) return;
        isDown = false;
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
        if (dragMoved) {
          suppressClick = true;             /* swallow the click that ends the drag */
          track.style.scrollSnapType = '';  /* restore snapping → snaps to nearest card */
        }
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      /* a swipe must not navigate to the card link */
      track.addEventListener('click', function (e) {
        if (suppressClick) {
          e.preventDefault();
          e.stopPropagation();
          suppressClick = false;
        }
      }, true);

      /* stop the native image/link ghost-drag while swiping */
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      /* --- quick add-to-cart (same flow as the product page) --- */
      section.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-pc-add]');
        if (!form) return;
        e.preventDefault();
        var btn = form.querySelector('[data-pc-add-btn]');
        if (btn && btn.disabled) return;
        if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        })
          .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
          .then(function (r) {
            if (!r.ok) throw r.data;
            return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); });
          })
          .then(function (cart) {
            /* open the cart drawer first so its refresh keeps it open, then broadcast */
            var drawer = document.querySelector('[data-drawer="cart"]');
            if (drawer) { drawer.removeAttribute('hidden'); document.body.classList.add('kis-nav-open'); }
            document.dispatchEvent(new CustomEvent('cart:update', { detail: cart }));
          })
          .catch(function (err) {
            console.warn('quick add failed', err);
            alert((err && err.description) || 'Could not add to cart');
          })
          .finally(function () {
            if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
          });
      });

      /* --- "swipe" custom drag cursor --- */
      var cursor = section.querySelector('[data-pc-cursor]');
      var viewport = section.querySelector('.product-carousel__viewport');
      var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (cursor && viewport && finePointer) {
        var rafId = null;
        var pendingX = 0, pendingY = 0;

        function place() {
          rafId = null;
          cursor.style.transform = 'translate(' + (pendingX - 60) + 'px, ' + (pendingY - 60) + 'px)';
        }
        function onMove(e) {
          pendingX = e.clientX;
          pendingY = e.clientY;
          if (rafId === null) rafId = window.requestAnimationFrame(place);
        }
        viewport.addEventListener('mouseenter', function (e) {
          pendingX = e.clientX; pendingY = e.clientY; place();
          section.classList.add('is-cursor-active');
        });
        viewport.addEventListener('mousemove', onMove);
        viewport.addEventListener('mouseleave', function () {
          section.classList.remove('is-cursor-active');
        });
        /* hide cursor while pressing arrows so it doesn't sit over the click */
        [prev, next].forEach(function (btn) {
          if (!btn) return;
          btn.addEventListener('mouseenter', function () { section.classList.remove('is-cursor-active'); });
          btn.addEventListener('mouseleave', function () { section.classList.add('is-cursor-active'); });
        });
      }
    }

    document.querySelectorAll('[data-section-type="product-carousel"]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="product-carousel"]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var toggle = root.querySelector('[data-review-toggle]');
      var formWrap = root.querySelector('[data-review-form]');
      if (toggle && formWrap) {
        toggle.addEventListener('click', function () {
          if (formWrap.hasAttribute('hidden')) formWrap.removeAttribute('hidden');
          else formWrap.setAttribute('hidden', '');
        });
        if (formWrap.querySelector('.product-reviews__form-success')) formWrap.removeAttribute('hidden');
      }

      // form star picker highlight
      var formStars = root.querySelectorAll('.product-reviews__form-star');
      function paintFormStars() {
        var checked = root.querySelector('.product-reviews__form-star input:checked');
        var val = checked ? parseInt(checked.value, 10) : 5;
        formStars.forEach(function (s, i) { s.classList.toggle('is-active', i < val); });
      }
      formStars.forEach(function (s) { s.addEventListener('change', paintFormStars); });
      paintFormStars();

      // show more
      var moreBtn = root.querySelector('[data-review-more]');
      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          root.querySelectorAll('[data-review-card].is-hidden').forEach(function (c) { c.classList.remove('is-hidden'); });
          moreBtn.parentElement.remove();
        });
      }

      // sort
      var sortSel = root.querySelector('[data-review-sort]');
      var list = root.querySelector('[data-review-list]');
      if (sortSel && list) {
        sortSel.addEventListener('change', function () {
          var cards = Array.prototype.slice.call(list.querySelectorAll('[data-review-card]'));
          cards.sort(function (a, b) {
            var ra = parseInt(a.getAttribute('data-rating'), 10), rb = parseInt(b.getAttribute('data-rating'), 10);
            var oa = parseInt(a.getAttribute('data-order'), 10), ob = parseInt(b.getAttribute('data-order'), 10);
            if (sortSel.value === 'highest') return rb - ra || oa - ob;
            if (sortSel.value === 'lowest') return ra - rb || oa - ob;
            return oa - ob;
          });
          cards.forEach(function (c) { list.appendChild(c); });
        });
      }

      // helpful voting (local only)
      root.querySelectorAll('[data-helpful-up], [data-helpful-down]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.hasAttribute('data-voted')) return;
          btn.setAttribute('data-voted', '');
          var n = btn.querySelector('span');
          n.textContent = parseInt(n.textContent, 10) + 1;
        });
      });
    }
    document.querySelectorAll('[data-section-type="product-reviews"]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="product-reviews"]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var slider = section.querySelector('[data-pspot-slider]');
      if (!slider || slider.dataset.pspotReady) return;
      slider.dataset.pspotReady = '1';

      /* --- quick add-to-cart (same flow as the product carousel) --- */
      section.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-ps-add]');
        if (!form) return;
        e.preventDefault();
        var btn = form.querySelector('[data-ps-add-btn]');
        if (btn && btn.disabled) return;
        if (btn) btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
          .then(function (r) {
            if (!r.ok) throw r.data;
            return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); });
          })
          .then(function (cart) {
            var drawer = document.querySelector('[data-drawer="cart"]');
            if (drawer) { drawer.removeAttribute('hidden'); document.body.classList.add('kis-nav-open'); }
            document.dispatchEvent(new CustomEvent('cart:update', { detail: cart }));
          })
          .catch(function (err) { console.warn('spotlight add failed', err); alert((err && err.description) || 'Could not add to cart'); })
          .finally(function () { if (btn) btn.disabled = false; });
      });

      var media = section.querySelector('[data-pspot-media]');
      var panel = section.querySelector('[data-pspot-panel]');
      var dots = Array.prototype.slice.call(section.querySelectorAll('[data-pspot-dot]'));
      var prev = section.querySelector('[data-pspot-prev]');
      var next = section.querySelector('[data-pspot-next]');
      var current = section.querySelector('[data-pspot-current]');
      var total = panel ? panel.children.length : 0;
      if (total <= 1) return;
      var index = 0;

      function render() {
        var x = 'translateX(' + (-index * 100) + '%)';
        if (media) media.style.transform = x;
        if (panel) panel.style.transform = x;
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
          d.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        if (current) current.textContent = index + 1;
        if (prev) prev.classList.toggle('is-hidden', index === 0);
        if (next) next.classList.toggle('is-hidden', index === total - 1);
      }

      function go(i) {
        index = Math.max(0, Math.min(total - 1, i));
        render();
      }

      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-pspot-dot'), 10)); });
      });

      // touch swipe (mobile, where arrows are hidden)
      var startX = null;
      slider.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      slider.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });

      render();
    }

    document.querySelectorAll('[data-section-type="product-spotlight"]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="product-spotlight"]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var track = section.querySelector('[data-rr-track]');
      if (!track || track.dataset.rrReady) return;
      track.dataset.rrReady = '1';

      var prev = section.querySelector('[data-rr-prev]');
      var next = section.querySelector('[data-rr-next]');
      var bar = section.querySelector('[data-rr-scrollbar]');
      var thumb = section.querySelector('[data-rr-thumb]');

      function step() {
        var card = track.querySelector('.real-results__card');
        if (!card) return 320;
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function maxScroll() { return track.scrollWidth - track.clientWidth; }

      function update() {
        var max = maxScroll();
        if (thumb) {
          var ratio = track.clientWidth / track.scrollWidth;
          var w = Math.max(8, Math.min(100, ratio * 100));
          thumb.style.width = w + '%';
          var prog = max > 0 ? track.scrollLeft / max : 0;
          thumb.style.left = (prog * (100 - w)) + '%';
        }
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max - 4;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);

      // click-to-seek + drag on the scrollbar
      function seekFromClientX(clientX) {
        var rect = bar.getBoundingClientRect();
        var ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
        track.scrollLeft = ratio * maxScroll();
      }
      if (bar) {
        var dragging = false;
        bar.addEventListener('pointerdown', function (e) { dragging = true; bar.setPointerCapture(e.pointerId); seekFromClientX(e.clientX); });
        bar.addEventListener('pointermove', function (e) { if (dragging) seekFromClientX(e.clientX); });
        bar.addEventListener('pointerup', function () { dragging = false; });
        bar.addEventListener('pointercancel', function () { dragging = false; });
      }

      // "swipe" cursor bubble following the pointer over the track (fine pointers only)
      var cursor = section.querySelector('[data-rr-cursor]');
      var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (cursor && finePointer) {
        var rafId = null, pendingX = 0, pendingY = 0;
        function place() {
          rafId = null;
          cursor.style.transform = 'translate(' + (pendingX - 60) + 'px, ' + (pendingY - 60) + 'px)';
        }
        function onMove(e) {
          pendingX = e.clientX; pendingY = e.clientY;
          if (rafId === null) rafId = window.requestAnimationFrame(place);
        }
        track.addEventListener('mouseenter', function (e) {
          pendingX = e.clientX; pendingY = e.clientY; place();
          section.classList.add('is-cursor-active');
        });
        track.addEventListener('mousemove', onMove);
        track.addEventListener('mouseleave', function () {
          section.classList.remove('is-cursor-active');
        });
      }

      // drag-to-scroll (capture the pointer only once a real drag starts, so links still click)
      var down = false, sx = 0, sl = 0, moved = false, suppress = false;
      var TH = 6;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (!moved && Math.abs(dx) > TH) {
          moved = true; track.classList.add('is-dragging');
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (moved) { track.scrollLeft = sl - dx; e.preventDefault(); }
      });
      function endDrag(e) {
        if (!down) return;
        down = false;
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
        if (moved) { suppress = true; track.classList.remove('is-dragging'); }
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('click', function (e) { if (suppress) { e.preventDefault(); e.stopPropagation(); suppress = false; } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      update();
    }

    document.querySelectorAll('[data-section-type="real-results"]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="real-results"]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      var input = root.querySelector('[data-search-input]');
      var results = root.querySelector('[data-search-results]');
      var defaultView = root.querySelector('[data-search-default]');
      if (!input || !results) return;
      var timer;

      function cardHTML(p) {
        var raw = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        var img = raw ? (raw + (raw.indexOf('?') > -1 ? '&' : '?') + 'width=260') : '';
        var imgTag = img ? '<img src="' + img + '" alt="" width="120" height="120" loading="lazy">' : '';
        return '<a href="' + p.url + '" class="search-drawer__result">' +
          '<span class="search-drawer__result-img">' + imgTag + '</span>' +
          '<span class="search-drawer__result-name">' + (p.title || '') + '</span>' +
        '</a>';
      }

      var noResultsText = results.getAttribute('data-no-results') || 'No results for';

      function showDefault() {
        results.setAttribute('hidden', '');
        results.innerHTML = '';
        if (defaultView) defaultView.removeAttribute('hidden');
      }

      function render(products, q) {
        if (defaultView) defaultView.setAttribute('hidden', '');
        results.removeAttribute('hidden');
        if (!products || !products.length) {
          results.innerHTML = '<p class="search-drawer__results-empty">' + noResultsText + ' "' + q + '"</p>';
          return;
        }
        results.innerHTML = products.map(cardHTML).join('');
      }

      function query(q) {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (input.value.trim().length < 2) { showDefault(); return; }
            var products = data && data.resources && data.resources.results ? data.resources.results.products : [];
            render(products, q);
          })
          .catch(function () { showDefault(); });
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { showDefault(); return; }
        timer = setTimeout(function () { query(q); }, 250);
      });

      /* suggestions: stay inside the drawer — fill the input and search inline (the reference) */
      root.querySelectorAll('.search-drawer__suggestion').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var term = link.textContent.trim();
          input.value = term;
          input.focus();
          clearTimeout(timer);
          query(term);
        });
      });

      /* Enter never leaves the drawer either — results are already live */
      var form = root.querySelector('[data-search-form]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var q = input.value.trim();
          if (q.length >= 2) { clearTimeout(timer); query(q); }
        });
      }

      // focus input when the drawer opens
      var drawer = root.closest('[data-drawer]') || root;
      var obs = new MutationObserver(function () {
        if (!drawer.hasAttribute('hidden')) { setTimeout(function () { input.focus(); }, 50); }
      });
      obs.observe(drawer, { attributes: true, attributeFilter: ['hidden'] });
    }

    document.querySelectorAll('[data-section-type="search-drawer"]').forEach(setup);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="search-drawer"]');
      if (el) setup(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var root = section.querySelector('[data-tc-root]');
      if (!root || root.dataset.tcReady) return;
      root.dataset.tcReady = '1';

      var toggles = Array.prototype.slice.call(section.querySelectorAll('[data-tc-toggle]'));
      var slides = Array.prototype.slice.call(section.querySelectorAll('[data-tc-slide]'));
      var medias = Array.prototype.slice.call(section.querySelectorAll('[data-tc-media]'));
      if (!toggles.length) return;

      function activate(i) {
        toggles.forEach(function (t, k) {
          var on = k === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        slides.forEach(function (s, k) {
          var on = k === i;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        medias.forEach(function (m, k) {
          var on = k === i;
          m.classList.toggle('is-active', on);
          m.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
      }

      toggles.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(i); });
        t.addEventListener('mouseenter', function () { activate(i); });
      });
    }

    document.querySelectorAll('[data-section-type="tabbed-content"]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="tabbed-content"]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ugc-card]'))
        .filter(function (c) { return c.querySelector('video'); });

      function pauseCard(card) {
        card.querySelector('video').pause();
        card.classList.remove('is-playing');
      }

      cards.forEach(function (card) {
        var video = card.querySelector('video');
        var btn = card.querySelector('[data-ugc-play]');
        if (!video || !btn) return;
        video.removeAttribute('autoplay');
        video.muted = false;

        /* play WITH sound — only one video at a time */
        btn.addEventListener('click', function () {
          cards.forEach(function (c) { if (c !== card) pauseCard(c); });
          video.muted = false;
          card.classList.remove('is-muted');
          video.play().catch(function () {});
          card.classList.add('is-playing');
        });

        /* small toggle: cut / restore the sound while playing */
        var muteBtn = card.querySelector('[data-ugc-mute]');
        if (muteBtn) {
          muteBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            video.muted = !video.muted;
            card.classList.toggle('is-muted', video.muted);
          });
        }

        /* click the playing video to pause it */
        video.addEventListener('click', function () {
          if (card.classList.contains('is-playing')) pauseCard(card);
        });

        /* keep the UI in sync whatever pauses/plays the video (browser, OS, etc.) */
        video.addEventListener('pause', function () { card.classList.remove('is-playing'); });
        video.addEventListener('play', function () {
          cards.forEach(function (c) { if (c !== card) pauseCard(c); });
          card.classList.add('is-playing');
        });
      });
    }
    document.querySelectorAll('[data-section-type="ugc-carousel"]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-section-type="ugc-carousel"]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
